import {ENTITY} from 'front-onceforall-core/dist/utils/users';
import {setUser} from '../../actions/user';
import {selectOrganisation} from '../../actions/organisation';
import {findOrganisation} from '../organisation/FakeOrganisationService';
import {MANAGER_ROLE, CONSULTANT_ROLE, INVITING_ROLE, EXPLORER_ROLE, USER_OPTIONS} from '../../utils/constant';

export const fakeUser = {
  id: 'some-uuid',
  email: 'beta@attestationlegale.fr',
  emailVerified: true,
  firstName: 'Beta',
  lastName: 'Onceforall',
  fullName: 'Beta Onceforall',
  language: 'en',
  phoneNumber: '+33472383258',
  organisationIds: ['1'],
  userOrganisations: [
    findOrganisation(1)
  ],
  // A very useful comment for Mister Zebille to say that this timestamp is equivalent to 26 of August 2019 at 15:48:24
  termsAndConditionsTimestamp: 1566834504,
  privacyPolicyTimestamp: 1566834504,
  entities: [ENTITY.FRANCE, ENTITY.GERMANY],
  options: [USER_OPTIONS.COLLECTOR_PERIODIC_PROJECT_REPORT, USER_OPTIONS.SUGGESTION_DISPLAY]
};

function getRoleFromLocalStorage() {
  return localStorage.getItem('backOfficeRole') ? localStorage.getItem('backOfficeRole') : MANAGER_ROLE;
}

export default class FakeAuthenticationService {
  init(store) {
    store.dispatch(setUser(fakeUser));
    store.dispatch(selectOrganisation(fakeUser.userOrganisations[0]));
    return Promise.resolve();
  }

  login() {
    // do nothing
  }

  logout() {
    // do nothing
  }

  updateTokenKeycloak() {
    return Promise.resolve('tokenKeycloak');
  }

  updateTokenRoles() {
    return Promise.resolve('tokenRoles');
  }

  authRedirect(url) {
    return Promise.resolve(url);
  }

  roles() {
    return {
      getCurrentOrganisationRole: () => this.getCurrentOrganisationRole(),
      isManager: () => this.isManager(),
      isConsultant: () => this.isConsultant(),
      isInviting: () => this.isInviting(),
      hasPermission: permission => this.hasPermission(permission),
      isBackOffice: () => this.isBackOffice(),
      isExplorer: () => this.isExplorer()
    };
  }

  getCurrentOrganisationRole() {
    return getRoleFromLocalStorage();
  }

  isBackOffice() {
    return localStorage.getItem('offlineMode_isBackOffice') === 'true';
  }

  isManager() {
    return getRoleFromLocalStorage() === MANAGER_ROLE;
  }

  isConsultant() {
    return getRoleFromLocalStorage() === CONSULTANT_ROLE;
  }

  isInviting() {
    return getRoleFromLocalStorage() === INVITING_ROLE;
  }

  isExplorer() {
    return getRoleFromLocalStorage() === EXPLORER_ROLE;
  }

  hasPermission(permission) {
    return localStorage.getItem(`offlineMode_hasPermission${permission}`) === 'true';
  }
}
